var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var learningLounge;
export var APIHeaders = {
    "X-Api-Key": "1faba317-dc44-4e87-a344-118ff1d731f6",
};
var host = window.location.hostname;
// apex domain check FIRST (before ngrok / localhost)
if (host.includes("apex") || host.includes("system")) {
    learningLounge = "https://system.learninglounge.com";
}
else if (host.includes("staging")) {
    learningLounge = "https://staging.learninglounge.com";
}
else if (host.includes("ngrok.app")) {
    learningLounge = "https://learninglounge.ngrok.app";
}
else if (host.includes("localhost") || host.includes("192.168")) {
    learningLounge = "https://localhost:44309";
}
else {
    learningLounge = "https://www.learninglounge.com";
}
var API = /** @class */ (function () {
    function API(args) {
        this.url = args.url;
        if (args === null || args === void 0 ? void 0 : args.method)
            this.method = args.method;
        if (args === null || args === void 0 ? void 0 : args.headers)
            this.headers = args.headers;
        if (args === null || args === void 0 ? void 0 : args.events)
            this.events = args.events;
        if (args === null || args === void 0 ? void 0 : args.credentials)
            this.credentials = args.credentials;
        if (args === null || args === void 0 ? void 0 : args.body)
            this.body = args.body;
        if (args === null || args === void 0 ? void 0 : args.responseType)
            this.responseType = args.responseType;
    }
    API.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.invoke()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    API.prototype.invoke = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, contentType, contentDisposition, isAttachment, isBinaryAuto, forcedType, data, resText, _a, _b, error_1;
            var _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 27, , 28]);
                        return [4 /*yield*/, fetch(this.url, __assign(__assign(__assign(__assign({}, (this.method ? { method: this.method } : {})), (this.headers ? { headers: this.headers } : {})), (this.body ? { body: this.body } : {})), (this.credentials ? { credentials: this.credentials } : {})))];
                    case 1:
                        response = _f.sent();
                        if (!response.ok)
                            throw new Error("HTTP error! status: ".concat(response.status));
                        contentType = (response.headers.get('content-type') || '').toLowerCase();
                        contentDisposition = (response.headers.get('content-disposition') || '').toLowerCase();
                        isAttachment = contentDisposition.includes('attachment');
                        isBinaryAuto = contentType.includes('application/pdf') ||
                            contentType.includes('application/octet-stream') ||
                            contentType.includes('application/zip') ||
                            contentType.startsWith('image/') ||
                            isAttachment;
                        forcedType = this.responseType ? String(this.responseType).toLowerCase() : null;
                        data = void 0;
                        if (!(forcedType === 'blob' || isBinaryAuto)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.blob()];
                    case 2:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 3:
                        if (!(forcedType === 'arraybuffer')) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 4:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 5:
                        if (!(forcedType === 'text')) return [3 /*break*/, 7];
                        return [4 /*yield*/, response.text()];
                    case 6:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 7:
                        if (!(forcedType === 'json')) return [3 /*break*/, 9];
                        return [4 /*yield*/, response.json()];
                    case 8:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 9:
                        if (!(forcedType === 'response' || forcedType === 'raw')) return [3 /*break*/, 10];
                        data = response;
                        return [3 /*break*/, 24];
                    case 10:
                        if (!(contentType.includes('application/json') || contentType.includes('application/ld+json'))) return [3 /*break*/, 12];
                        return [4 /*yield*/, response.json()];
                    case 11:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 12:
                        if (!(contentType.includes('application/xml') ||
                            contentType.includes('text/xml') ||
                            contentType.includes('application/atom+xml'))) return [3 /*break*/, 14];
                        return [4 /*yield*/, response.text()];
                    case 13:
                        resText = _f.sent();
                        data = new DOMParser().parseFromString(resText, 'text/xml');
                        return [3 /*break*/, 24];
                    case 14:
                        if (!contentType.includes('text/plain')) return [3 /*break*/, 16];
                        return [4 /*yield*/, response.text()];
                    case 15:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 16:
                        _f.trys.push([16, 18, , 24]);
                        return [4 /*yield*/, response.json()];
                    case 17:
                        data = _f.sent();
                        return [3 /*break*/, 24];
                    case 18:
                        _a = _f.sent();
                        _f.label = 19;
                    case 19:
                        _f.trys.push([19, 21, , 23]);
                        return [4 /*yield*/, response.text()];
                    case 20:
                        data = _f.sent();
                        return [3 /*break*/, 23];
                    case 21:
                        _b = _f.sent();
                        return [4 /*yield*/, response.blob()];
                    case 22:
                        data = _f.sent();
                        return [3 /*break*/, 23];
                    case 23: return [3 /*break*/, 24];
                    case 24:
                        if (!((_c = this.events) === null || _c === void 0 ? void 0 : _c.success)) return [3 /*break*/, 26];
                        return [4 /*yield*/, this.events.success(data)];
                    case 25:
                        _f.sent();
                        _f.label = 26;
                    case 26: return [2 /*return*/, data];
                    case 27:
                        error_1 = _f.sent();
                        if ((_d = this.events) === null || _d === void 0 ? void 0 : _d.error) {
                            this.events.error(error_1);
                        }
                        else {
                            console.log(error_1, 'error from api');
                            throw new Error("Error fetching data: ".concat((_e = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== null && _e !== void 0 ? _e : error_1));
                        }
                        return [3 /*break*/, 28];
                    case 28: return [2 /*return*/];
                }
            });
        });
    };
    return API;
}());
export { API };
